<div class="question-container">
      <label [innerHTML]="label" [class.required]="isRequired && label" ></label>
<mat-form-field appearance="outline" class="form-control-width">
 
  <mat-select
    [formControl]="control"
    [placeholder]="placeholder"
    [compareWith]="compareWith">
    @if(lookupItems != null) {
       @for (option of lookupItems; track option.id) {
      <mat-option [value]="getValue(option)">{{ option.value }}</mat-option>
       }
    }
    @else if(visaTypes != null) {
      @for (option of visaTypes; track option.id) {
      <mat-option [value]="getValue(option)">{{ option.VisaType }}</mat-option>
      }
    }
    @else {
       @for (option of options; track option.value) {
      <mat-option [value]="getValue(option)">{{ option.label }}</mat-option>
    }
    }
  </mat-select>
  @for(msg of errorMessages; track msg){
  <mat-error>
    {{ showError ? msg : '' }}
  </mat-error>
  }
  <!-- @if (showError && errorMessages.length) {
    @for (msg of errorMessages; track msg) {
      <mat-error>{{ msg }}</mat-error>
    }
  } -->
</mat-form-field>
</div>
